import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://tapiotulenheimo.fi';

export default function SEO({ t, lang }) {
  const isEn = lang === 'en';
  const canonical = isEn ? `${BASE_URL}/en/` : `${BASE_URL}/`;

  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{t.seo.title}</title>
      <meta name="description" content={t.seo.description} />
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hreflang="fi" href={`${BASE_URL}/`} />
      <link rel="alternate" hreflang="en" href={`${BASE_URL}/en/`} />
      <link rel="alternate" hreflang="x-default" href={`${BASE_URL}/`} />
      <meta property="og:title" content={t.seo.ogTitle} />
      <meta property="og:description" content={t.seo.ogDescription} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:title" content={t.seo.ogTitle} />
      <meta name="twitter:description" content={t.seo.ogDescription} />
    </Helmet>
  );
}
